<st-avatar
    big
    [userId]="userId()"
    [matMenuTriggerFor]="menu"
    (click)="openMenu()" />
<mat-menu
    #menu="matMenu"
    st-click-stop-propagation
    (closed)="closeMenu()">
    <ng-template matMenuContent>
        <div
            class="st-user-menu-container-header"
            [dir]="isRTL()"
            [class.st-user-menu-container-header-submenu]="this.currentMenu() !== settingsMenuTemplate[0].OVERALL">
            @if (this.currentMenu() !== settingsMenuTemplate[0].OVERALL) {
                <button
                    mat-menu-item
                    st-click-stop-propagation
                    class="st-user-menu-container-header-btn"
                    (click)="backButton()">
                    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
                </button>
            }
            <st-avatar
                big
                [userId]="userId()">
                <st-avatar
                    upload
                    st-click-stop-propagation
                    [editAvatar]="clickSubject"
                    [userId]="userId()"
                    (click)="openFile($event)" />
            </st-avatar>
            @if (this.currentMenu() === settingsMenuTemplate[0].OVERALL) {
                <div class="st-user-menu-container-header-info">
                    <span
                        class="st-user-menu-container-header-info-username"
                        [title]="userDisplayName()">
                        {{ userDisplayName() }}
                    </span>
                    <span
                        class="st-user-menu-container-header-info-team"
                        [title]="userDepartment()">
                        {{ userDepartment() }}
                    </span>
                </div>
            }
        </div>

        @switch (currentMenu()) {
            <!-- Notification Menu  -->
            @case ('NOTIFICATIONS') {
                <span
                    class="st-user-menu-submenu-title"
                    [title]="languageSettings().PSTWebNotificationSettings">
                    {{ languageSettings().PSTWebNotificationSettings }}
                </span>
                <div class="st-user-menu-submenu">
                    <span>{{ languageSettings().PSTWebNotificationDescription }}</span>
                    <st-check-box
                        st-click-stop-propagation
                        [label]="this.languageSettings().PSTWebNotificationMobileLabel"
                        [value]="pstNotificationSettings().Mobile.Recieve"
                        (changed)="mobileChanged($event)" />
                    <st-check-box
                        st-click-stop-propagation
                        [label]="this.languageSettings().PSTWebNotificationTextLabel"
                        [value]="pstNotificationSettings().Phone.Recieve"
                        (changed)="textChanged($event)" />
                    <st-text-field
                        st-click-stop-propagation
                        only-number
                        [placeholder]="languageSettings().PSTWebNotificationTextInputLabel"
                        [value]="pstNotificationSettings().Phone.Input"
                        [disabled]="isDisabled"
                        (changed)="textChanged($event)" />
                </div>
            }
            <!-- Region and Language Menu-->
            @case ('REGIONANDLANGUAGE') {
                <span
                    class="st-user-menu-submenu-title"
                    [title]="languageSettings().PSTWebRegionAndLanguage">
                    {{ languageSettings().PSTWebRegionAndLanguage }}
                </span>
                <div class="st-user-menu-submenu">
                    <st-combo-box
                        st-click-stop-propagation
                        class="st-user-menu-submenu-time-zone"
                        [addSeparatorAfterEmptyOption]="true"
                        [label]="timeZoneLabel()"
                        [addEmptyOption]="true"
                        [value]="timeZoneValue()"
                        [additionalItemList]="ianaTimeZones()"
                        [itemList]="commonTimeZones()"
                        (changed)="timezoneChanged($event)" />
                    <st-combo-box
                        st-click-stop-propagation
                        class="st-user-menu-submenu-language"
                        [label]="languageSettings().PSTWebDefaultLanguageLabel"
                        [addEmptyOption]="true"
                        [addSeparatorAfterEmptyOption]="true"
                        [itemList]="languages()"
                        [value]="languageValue()"
                        (changed)="languageChanged($event)" />
                    <st-combo-box
                        st-click-stop-propagation
                        class="st-user-menu-submenu-language"
                        [label]="languageSettings().PSTWebStartWeekDay"
                        [addEmptyOption]="true"
                        [addSeparatorAfterEmptyOption]="true"
                        [itemList]="weekDays()"
                        [value]="dayOfWeekValue()"
                        (changed)="weekDayChanged($event)" />
                    <st-toggle-control
                        st-click-stop-propagation
                        class="st-user-menu-submenu-toggle-button"
                        [label]="rtlLabel()"
                        [value]="rtl()"
                        (changed)="rtlChanged($event)" />
                </div>
            }
            <!-- Default Menu-->
            @default {
                <div
                    class="st-user-menu-main"
                    [dir]="isRTL()">
                    <button
                        mat-menu-item
                        st-click-stop-propagation
                        (click)="showNotificationSettings()">
                        <mat-icon class="material-symbols-outlined">edit_notifications</mat-icon>
                        <span [title]="languageSettings().PSTWebNotificationSettings">{{ languageSettings().PSTWebNotificationSettings }}</span>
                    </button>
                    <button
                        mat-menu-item
                        st-click-stop-propagation
                        (click)="showRegionAndLanguageSettings()">
                        <mat-icon class="material-symbols-outlined">language</mat-icon>
                        <span [title]="languageSettings().PSTWebRegionAndLanguage">{{ languageSettings().PSTWebRegionAndLanguage }}</span>
                    </button>
                    @if (supervisor()) {
                        <button
                            mat-menu-item
                            (click)="showManageTeamMembers()">
                            <mat-icon class="material-symbols-outlined">group</mat-icon>
                            <span [title]="languageSettings().PSTWebTeamMembers">{{ languageSettings().PSTWebTeamMembers }}</span>
                        </button>
                    }
                    @if (shouldShowPublicationChannels()) {
                        <button
                            mat-menu-item
                            (click)="showManagePublicationChannels()">
                            <mat-icon class="material-symbols-outlined">podcasts</mat-icon>
                            <span [title]="languageSettings().PSTWebPublicationChannel">{{ languageSettings().PSTWebPublicationChannel }}</span>
                        </button>
                    }
                    @if (hasAdminSettings()) {
                        <button
                            mat-menu-item
                            (click)="showAdminSettings()">
                            <mat-icon>key</mat-icon>
                            <span [title]="languageSettings().PSTWebDiscoverAdminSettingsLabel">{{ languageSettings().PSTWebDiscoverAdminSettingsLabel }}</span>
                        </button>
                    }
                    <div mat-menu-item>
                        <st-toggle-control
                            st-click-stop-propagation
                            class="st-user-menu-submenu-toggle-button st-user-menu-submenu-toggle-button-dark-mode"
                            [label]="languageSettings().PSTWebDarkModeLabel"
                            [value]="selectDarkMode()"
                            (changed)="toggleDarkMode()">
                            <mat-icon
                                before
                                class="material-symbols-outlined">
                                mode_night
                            </mat-icon>
                        </st-toggle-control>
                    </div>
                </div>
                <div [dir]="isRTL()">
                    <a
                        mat-menu-item
                        target="_blank"
                        [href]="playbookHelpUrl()">
                        <mat-icon class="material-symbols-outlined">help</mat-icon>
                        <span [title]="languageSettings().PSTWebHelp">{{ languageSettings().PSTWebHelp }}</span>
                    </a>
                    <button
                        mat-menu-item
                        (click)="showAbout($event)">
                        <mat-icon class="material-symbols-outlined">info</mat-icon>
                        <span [title]="languageSettings().PSTWebAbout">{{ languageSettings().PSTWebAbout }}</span>
                    </button>
                    <button
                        mat-menu-item
                        (click)="logoutUser()">
                        <mat-icon class="material-symbols-outlined">output</mat-icon>
                        <span [title]="languageSettings().PSTWebLogout">{{ languageSettings().PSTWebLogout }}</span>
                    </button>
                </div>
            }
        }
    </ng-template>
</mat-menu>
